module.exports = __webpack_public_path__ + "static/media/exclamation-circled.c2357a51.svg";